import React, { useState, useRef, useEffect } from 'react';
import { Navigation } from './navigation';
import { CarouselWrapper, CarouselItemsWrapper } from './styles';
function StepCarousel({ children, onScroll, previousSlideLabel, nextSlideLabel, singleStep = false, carouselLabel, ...rest }) {
    const [carouselPosition, setCarouselPosition] = useState(0);
    const [showEndArrow, setShowEndArrow] = useState(false);
    const carouselWrapperEl = useRef(null);
    const carouselContentsEl = useRef(null);
    const previousSlide = () => {
        const firstChild = carouselContentsEl.current.firstChild;
        const singleItemWidth = Math.ceil(firstChild === null || firstChild === void 0 ? void 0 : firstChild.getBoundingClientRect().width) ||
            carouselWrapperEl.current.offsetWidth;
        const offset = carouselPosition -
            (singleStep ? singleItemWidth : carouselWrapperEl.current.offsetWidth);
        setCarouselPosition(offset <= 0 ? 0 : offset);
        if (onScroll) {
            onScroll();
        }
    };
    const nextSlide = () => {
        const firstChild = carouselContentsEl.current.firstChild;
        const singleItemWidth = Math.ceil(firstChild === null || firstChild === void 0 ? void 0 : firstChild.getBoundingClientRect().width) ||
            carouselWrapperEl.current.offsetWidth;
        let offset = carouselPosition +
            (singleStep ? singleItemWidth : carouselWrapperEl.current.offsetWidth);
        const { offsetWidth: carouselWidth, scrollWidth: carouselScrollWidth } = carouselContentsEl.current;
        if (offset + carouselWidth > carouselScrollWidth) {
            offset = carouselScrollWidth - carouselWidth;
        }
        setCarouselPosition(offset);
        if (onScroll) {
            onScroll();
        }
    };
    const onTabNavigation = (e) => {
        const { offsetLeft: left } = e.target;
        const { offsetWidth: carouselWidth } = carouselContentsEl.current;
        const elemComputedOffsetLeft = left - carouselPosition;
        if (elemComputedOffsetLeft > carouselWidth) {
            nextSlide();
        }
        else if (elemComputedOffsetLeft < 0) {
            previousSlide();
        }
    };
    const styles = { transform: `translate3d(-${carouselPosition}px,0,0)` };
    const isAtStart = carouselPosition === 0;
    useEffect(() => {
        const hideEndArrowWhenScrollReachedEnd = !!carouselContentsEl.current &&
            carouselPosition + carouselContentsEl.current.offsetWidth ===
                carouselContentsEl.current.scrollWidth;
        if (showEndArrow !== hideEndArrowWhenScrollReachedEnd) {
            setShowEndArrow(hideEndArrowWhenScrollReachedEnd);
        }
    }, [setShowEndArrow, carouselPosition]);
    return (React.createElement(CarouselWrapper, { role: "region", "aria-label": carouselLabel, ref: carouselWrapperEl },
        React.createElement(Navigation, { onClick: previousSlide, previous: true, hide: isAtStart, label: previousSlideLabel }),
        React.createElement(Navigation, { onClick: nextSlide, hide: showEndArrow, label: nextSlideLabel }),
        React.createElement(CarouselItemsWrapper, Object.assign({ style: styles, onRef: carouselContentsEl, onTabNavigation: onTabNavigation }, rest), children)));
}
export default StepCarousel;
//# sourceMappingURL=component.js.map